export default __webpack_public_path__ + "static/media/astro.96b0dec3.glb";